/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */export default function formatMuiErrorMessage(code){// Apply babel-plugin-transform-template-literals in loose mode
// loose mode is safe iff we're concatenating primitives
// see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
/* eslint-disable prefer-template */var url='https://mui.com/production-error/?code='+code;for(var i=1;i<arguments.length;i+=1){// rest params over-transpile for this case
// eslint-disable-next-line prefer-rest-params
url+='&args[]='+encodeURIComponent(arguments[i]);}return'Minified MUI error #'+code+'; visit '+url+' for the full message.';/* eslint-enable prefer-template */}